jQuery(function ($) {
  const post = $('.singlePost');

  post.find('a[href$=".png"], a[href$=".jpg"]').addClass('is-lightbox');

  const prvs = new Parvus({
    selector: '.is-lightbox',
    gallerySelector: '.singlePost'
  });
});
